import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Convert a 24-hour "HH:MM" string to a 12-hour label like "7:00 AM" / "4:30 PM".
// Safe for empty / malformed values — returns "" when the hour can't be parsed.
export function fmt12(t) {
  if (!t) return "";
  const [hRaw, mRaw] = String(t).split(":");
  const h = Number(hRaw);
  if (Number.isNaN(h)) return "";
  const m = Number(mRaw) || 0;
  const period = h >= 12 ? "PM" : "AM";
  const hh = ((h + 11) % 12) + 1;
  return `${hh}:${m.toString().padStart(2, "0")} ${period}`;
}
